module.exports = __webpack_public_path__ + "img/7.b20c3a20.png";